import { useMemo } from 'react';
import { SchedulingLeg } from '../../../types/scheduling';

interface LCStatusCountsWidgetProps {
  legs: SchedulingLeg[];
}

export default function LCStatusCountsWidget({ legs }: LCStatusCountsWidgetProps) {
  const counts = useMemo(() => {
    return {
      pending: legs.filter(leg => leg.schedule_status === 'PENDING').length,
      pendingCustomer: legs.filter(leg => leg.schedule_status === 'PENDING_CUSTOMER').length,
      hold: legs.filter(leg => leg.schedule_status === 'HOLD').length,
    };
  }, [legs]);

  return (
    <div className="flex-shrink-0 border border-gray-300 dark:border-gray-600 rounded overflow-hidden">
      <table className="text-xs border-collapse">
        <thead>
          <tr className="bg-slate-700 text-white">
            <th className="px-4 py-1.5 text-center font-semibold">PENDING LC</th>
            <th className="px-4 py-1.5 text-center font-semibold">PENDING CUSTOMER</th>
            <th className="px-4 py-1.5 text-center font-semibold">HOLD</th>
          </tr>
        </thead>
        <tbody className="bg-panel">
          <tr>
            <td className="px-4 py-1.5 text-center font-semibold text-heading">
              {counts.pending}
            </td>
            <td className="px-4 py-1.5 text-center font-semibold text-heading">
              {counts.pendingCustomer}
            </td>
            <td className="px-4 py-1.5 text-center font-semibold text-heading">
              {counts.hold}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
